import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import PageHero from '../components/PageHero';
import Skills from '../components/Skills';

const pageVariants = {
  initial: { opacity: 0, x: 40 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -40 },
};

const SkillsPage = () => (
  <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={{ duration: 0.35 }}>
    <PageHero
      title="Technical"
      highlight="Skills"
      subtitle="A comprehensive overview of my testing methodologies, tools, automation frameworks, and technical proficiencies."
      pattern="dots"
    />
    <Skills hideTitle />
    {/* CTA */}
    <section className="section-padding bg-white dark:bg-dark-100 transition-colors duration-300">
      <div className="container-custom text-center">
        <p className="text-secondary-600 dark:text-gray-100 mb-4">See my certifications that back these skills.</p>
        <Link to="/certifications" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700 transition-colors">
          View Certifications <FiArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  </motion.div>
);

export default SkillsPage;
